import { render, staticRenderFns } from "./AdminPanelEpicentrkShoppingPacket.vue?vue&type=template&id=ab979fb4&"
import script from "./AdminPanelEpicentrkShoppingPacket.vue?vue&type=script&lang=js&"
export * from "./AdminPanelEpicentrkShoppingPacket.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanelEpicentrkShoppingPacket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VFlex,VIcon,VSelect,VTextarea,VToolbar,VToolbarTitle})
